<template>
  <div class="animated fadeIn">
    <br />
    <b-row>
      <b-col>
        <spinner v-if="loadingData"/>
        <b-card v-if="templatesItems && templatesItems.length > 0 && !loadingData" :header="caption">
          <table class="table table-responsive-sm">
          <thead>
            <tr>
              <th>Instagram</th>
              <th>Contador de Usos</th>
              <th>Relevância</th>
              <th>Express</th>
              <th>Avançado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" v-bind:key="item._id">
              <td><img v-bind:src="item.thumbnail" height="100" width="100"></td>
              <td>{{item.countUse > 0 ? item.countUse : 0}} <br> <a v-bind:href="'/template/editions/' + item._id" target="_blank">
                <div>Detalhes</div>
              </a></td>
              <td>{{item.weight}}</td>
              <td>{{item.expressEdition == true ? "Sim" : "Não"}}</td>
              <td>{{item.advancedEdition == true ? "Sim" : "Não"}}</td>
            </tr>
          </tbody>
        </table>
          <nav>
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Anterior"
              next-text="Próxima"
              hide-goto-end-buttons
              v-on:input="getTemplatesInfo"
            />
          </nav>
        </b-card>
        
      </b-col>
    </b-row>
  </div>
</template>

<script>
import service from "./../service";
import Multiselect from "vue-multiselect";
import Spinner from "./Spinner";
import Config from "../config";
import { constants } from "fs";

export default {
  name: "ManageDesign",
  inheritAttrs: false,
  props: {
    caption: {
      type: String,
      default: "Sleekers"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 24
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1,
      items: [],
      totalTemplates: 0,
      fields: {
        thumbnail: {
          label: "Imagem"
        },
        countUse: {
          label: "Contador de Usos"
        },
        weight: {
          label: "Relevância"
        },
        expressEdition: {
          label: "Express"
        },
        advancedEdition: {
          label: "Avançado"
        }
      },
      loadingData: true,
      info: {}
    };
  },
  computed: {
    captions: function() {
      return this.fields;
    },
    templatesItems: function() {
      return this.items;
    },
    totalRows: function() {
      return this.getRowCount();
    }
  },
  methods: {
    getRowCount: function() {
      return this.totalTemplates;
    },
    getTemplatesInfo: function() {
      this.items = [];
      this.loadingData = true;
      service
        .getTemplatesInfo({
          currentPage: this.currentPage
        })
        .then(response => {
          this.loadingData = false;
          this.items = response.templates;
          this.totalTemplates = response.totalItens;
        });
    }
  },
  created() {
    this.getTemplatesInfo();
  },
  components: { Multiselect, Spinner }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



<style lang="css" scoped>
.background-multiSelect >>> .multiselect__tag {
  background: #20a8d8 !important;
}
</style>


<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
